import { graphql } from "gatsby";
import React from "react";

import Layout from "../components/layout";
import TwoColumnLocationPageComponent from "../components/location-page/twoColumnLocationPageComponent";
import Newsletter from "../components/newsletter";
import Seo from "../components/seo";
import { ThemeContext } from "../context/ThemeContext";
import { useBannerDetails } from "../hooks/useBannerManager";

const TwoColumnLocationPageTemplate = ({ data }) => {
  const page = data?.page;

  const { acfLandingPage } = page;
  const wpTemplate =
    page && data && page.template && page.template.templateName
      ? page.template.templateName.toLowerCase()
      : "default";
  const groupProgramSourceType =
    acfLandingPage?.genProgramListSourceType === "group_programs";

  //filters set in the landing page options
  const getFilterByLocation =
    acfLandingPage?.genProgramLocation?.flatMap((loc) => loc?.slug) ?? [];

  const getFilterByProgramExtraTypes =
    acfLandingPage?.genProgramExtraTypes?.flatMap((type) => type?.slug) ?? [];

  const getFilterByProgramType =
    acfLandingPage?.genProgramType?.flatMap((type) => type?.slug) ??
    acfLandingPage?.genGroupProgramType?.flatMap((type) => type?.slug) ??
    [];

  // console.debug("debug page :: TwoLocationPageTemplate", {
  //   wpTemplate: wpTemplate,
  //   title: page?.title,
  //   template: page?.template?.templateName?.toLowerCase(),
  //   slug: page?.slug,
  //   pageFilters: {
  //     getFilterByProgramType,
  //     getFilterByProgramExtraTypes,
  //     getFilterByLocation
  //   }
  // });

  const isHomepage = false;

  const basicPageConfig = {
    page,
    genericDetails: data?.genericDetails,
    getFilterByLocation
  };

  let filterByProgramType =
    getFilterByProgramType && getFilterByProgramType?.length > 0
      ? `program_type=${getFilterByProgramType}`
      : "";
  let filterByProgramLocation =
    getFilterByLocation && getFilterByLocation?.length > 0
      ? `program_location=${getFilterByLocation}`
      : "";

  let applyNow = [
    "/application-form/",
    [filterByProgramType, filterByProgramLocation].filter(Boolean).join("&")
  ]
    .filter(Boolean)
    .join("?");
  let enquireNow = "/enquiry-form/";

  if (groupProgramSourceType === true) {
    applyNow = `/application-form/?group_source=${true}`;
    enquireNow = `/enquiry-form/?type=group_enquiry`;
  }

  const { stickyTitle, stickyImage, stickyDesc } =
    data?.genericDetails?.globalProgramConfig?.acfGenericGlobalConfig ?? {};

  const banner = useBannerDetails(page?.slug);

  const enquireUKCardDetails = {
    footerTitle: banner?.title ?? "",
    footerSubtitle: banner?.desc ?? "",
    footerImage: banner?.image || null,
    cardBookDesc: "",
    enquireNowCtaTitle: "Enquire",
    footerCtaTitle: "Apply",
    footerSubtitleClass: "text-sm dark:text-white text-black-lighter",
    contentContainerClass: "sm:w-2/5",
    cardBookDescSpanClass:
      "text-xs font-semibold text-left sm:font-normal dark:text-white text-generic-text",
    applicationFormLink: applyNow,
    enquireNowLink: enquireNow,
    enquireBtn: true,
    allowCookieControl: false,
    displayCloseButton: false,
    footerPromoCookieName: [
      "isPromoStickyFooterShow",
      page?.id ?? page?.slug
    ].join("")
  };

  return (
    <ThemeContext.Consumer>
      {(theme) => (
        <Layout
          pageTitle={page.title}
          containerClass={isHomepage ? "w-full mx-auto" : "w-full mx-auto"}
          enquireNow={enquireNow}
          applyNow={applyNow}
          brandingOpts={{ ...theme }}
          stickyFooterDetails={enquireUKCardDetails}
        >
          <TwoColumnLocationPageComponent {...basicPageConfig} />

          <Newsletter headerCol={"sm:bg-white dark:sm:bg-gray-light"} />
        </Layout>
      )}
    </ThemeContext.Consumer>
  );
};

export const Head = ({ data }) => {
  const page = data?.page ?? {};
  return (
    <Seo
      title={page?.seoLegacy?.title ?? page?.seo?.title ?? page.title}
      description={page?.seoLegacy?.description ?? page?.seo?.description}
      image={page?.globalConfig?.backgroundImage?.sourceUrl}
      translations={page?.translations}
      lang={page?.locale}
      meta={[
        {
          name: "robots",
          content: page?.seoLegacy?.robots ?? page?.seo?.robots
        }
      ]}
    />
  );
};

export const pageQuery = graphql`
  query ($id: String!) {
    page: wpPage(id: { eq: $id }) {
      ...VolunteerInLocationFragment
    }

    genericDetails: wp {
      globalProgramConfig: gviConfigSettings {
        acfKeyMessagingIcons {
          ...AcfKeymessagingiconsFragment
        }
        acfGenericGlobalConfig {
          ...StickyWidgetFragment
        }
      }
      countryExploration: gviCountryExplorationSettings {
        ...WpCountryExplorationFragment
      }
      ingoPrograms: acfOptionsIngoProgramsConfig {
        ingoPrograms {
          sidebarBookWithConfidenceWidget {
            stickyBottomWidget {
              ingoStickyTitle
              ingoStickyDesc
              ingoStickyBookNowText
              ingoStickyImage {
                ...smallGalleryData
              }
            }
          }
        }
      }
    }
  }
`;

export default TwoColumnLocationPageTemplate;
